/* eslint-disable import/prefer-default-export */

// 針對頁面callback
export function callbackRedirect(to, from, next, canShare) {
  // to 為callback，前往活動首頁
  if (/^callback$/i.test(to.name)) {
    next({
      name: canShare ? 'FrontPage' : 'FrontPageFake',
      params: {
        eventId: to.params.eventId,
        companyId: to.params.companyId,
        memberSourceId: to.params.memberSourceId,
        activityId: to.params.activityId,
      },
    });
  } else {
    next();
  }
}
